import css from 'styled-jsx/css';
import { common } from '../../../theme/theme';

const style = css`
  .booking-vehicle-edit-modal {
    width: 380px;
    padding: 16px;
  }
  .label {
    font-size: 14px;
  }
  .booking-vehicle-edit-modal-inputs {
    width: 100%;
  }
  .booking-vehicle-edit-wrapper,
  .reason-selector-wrapper {
    margin-bottom: 8px;
  }
  .booking-vehicle-edit-modal :global(.submit-button) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
  }
  .booking-vehicle-edit-modal :global(.submit-button:hover) {
    margin-top: 24px;
    ${common.button}
    ${common.submitButton}
  }
  .booking-vehicle-edit-modal :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
  .booking-vehicle-edit-modal :global(.cancel-button:hover) {
    ${common.button}
    ${common.cancelButton}
  }
`;

export default style;
